<script>
    import { Router, Route, Link } from 'svelte-routing';
</script>

<style>

/* Background video styles */
.video-background {
    position: relative;
    width: 100%;
    /* Remove height to let it adjust based on content */
    overflow: hidden;
    flex-shrink: 0;
}

/* Container for content to ensure it's above the video */
.about {
    z-index: 4;
    color: white;
    width: 70vh;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 6vh;
    background-color: rgba(0, 0, 0, 0.9); /* Halvgenomskinlig grå bakgrund */
    border-radius: 15px; /* Rundade hörn */
    padding: 40px; /* Inre marginal */
    transition: transform 0.6s ease, box-shadow 0.6s ease;
    font-family: 'MuseoModerna';
    display: flex;
    flex-direction: column;
}

.content-wrapper {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 800px;
}

.column {
    flex: 1;
    padding: 10px;
}

.about:hover {
    transform: scale(1.01);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.5);
}

.about-header {
    font-size: 2em;
    margin-bottom: 20px;
    position: relative;
}

.about-header::after {
    content: '';
    position: absolute;
    transform: translateX(-50%);
    bottom: -10px;
    left: 20%;
    width: 40%;
    height: 2px;
    background-color: #999; /* Linje mellan header och brödtext */
}

.header {
    padding-top: 50px;
    background-color: black;
    height: 100px;
    width: 100%;
    top: -5px;
    z-index: 4;
    position: relative;
}

.title {
    bottom: 18px;
}

.symbol {
    width: 350px;
}

.logo-link {
    text-decoration: none;
    color: inherit;
    display: block;
    z-index: 2;
}

.logo-link:hover {
    cursor: pointer;
}

.header:hover .block {
  animation: rotateBlocks 2.5s infinite linear;
}

footer {
    z-index: 2;
    position: fixed;
}

@keyframes rotateBlocks {
  0%   { transform: rotate(0deg); }
  20%  { transform: rotate(180deg); }  /* Fast rotation: 180deg in 20% of time */
  50%  { transform: rotate(225deg); }  /* Slow rotation: 45deg in 30% of time */
  70%  { transform: rotate(315deg); }  /* Fast rotation: 90deg in 20% of time */
  100% { transform: rotate(360deg); }  /* Slow rotation: 45deg in 30% of time */
}

.page-container {
    min-height: 100vh; /* Ensures the container covers the full viewport height */
    background-color: black; /* Fallback background color */
    width: 100%;
}

.video-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 700px; /* Covers the entire video container */
    z-index: 0; /* Places the video behind the content */
    object-fit: cover;
}

.video-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 700px;
    background-color: rgba(0, 0, 0, 0.6); /* White with 80% opacity */
    z-index: 1; /* Ensure it is on top of the video */
    pointer-events: none; /* Allows clicks to pass through to elements below */
}

.about-contact-container {
    background-color: black;
    z-index: 100;
    color: white;
    width: 800px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    padding-top: 50px;
}

.index-number {
    color: #999;
    font-size: 2em;
}

.index-text {
    margin-left: 15px;
}

.about-section-title {
    font-family: 'MuseoModerna';
    font-size: 2em;
}

.divider {
    height: 2px; /* Thickness of the divider */
    background-color: #999; /* Color of the divider */
    margin: 15px auto; /* Spacing around the divider */
    border-radius: 5px; /* Optional: Adds rounded edges */
}

.index-text {
    position: relative;
    text-decoration: none;
    color: inherit;
}

.index-number {
    margin-right: 15px;
}

/* Divider styles */
.index-text::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -5px; /* Adjusts the position of the divider below the text */
    width: 0; /* Initial width of the divider */
    height: 2px; /* Thickness of the divider */
    background-color: var(--hover); /* Color of the divider */
    transition: width 0.3s ease; /* Smooth transition for the divider growth */
}

/* Hover effect */
.index-text:hover::after {
    width: 100%; /* Grows to the full width of the text */
}

/* Optional: Change text color on hover */
.index-text:hover {
    color: var(--hover);
}

@media (max-width: 840px) {
    .about {
        width: 70%;
    }

    .about-contact-container {
        padding-left: 20px;
        padding-right: 20px;
        width: 90% !important;
    }

    .about-header::after {
        width: 80%;
        left: 40%;
}
}

</style>

<!-- Background Video -->


<!-- Content -->
<div class="page-container">
    <a href="/" class="logo-link">
        <div class="header">
            <div class="symbol">
                <!-- Your logo content -->
                <div class="line-vertical line-v1"></div>
                <div class="line-vertical line-v2"></div>
                <div class="line-horizontal line-h1"></div>
                <div class="line-horizontal line-h2"></div>
                <div class="block block-1"></div>
                <div class="block block-2"></div>
                <div class="block block-3"></div>
                <div class="block block-4"></div>
                <div class="title">boanalys<span class="tm">™</span></div>
            </div>
        </div>
    </a>
    <div class="video-container">
        <!-- Background Video -->
        <video autoplay muted loop playsinline class="video-background">
            <source src="/about.mp4" type="video/mp4" />
            Din video supporterar inte video.
        </video>
        <div class="video-overlay"></div>
        <div class="about">  
            <!-- About Text -->
            <div class="about-header">Innehåll</div>
            <div class="content-wrapper">
                <!-- Left Column -->
                <div class="column">
                    <br>
                    <div class="index-text-wrapper">
                        <a href="#om-oss-section" class="index-text">
                            <span class="index-number">01</span>
                            <span style="margin-left: 15px;">allmänt</span>
                        </a>
                    </div>
                    <div class="index-text-wrapper">
                        <a href="#service-section" class="index-text">
                            <span class="index-number">02</span>
                            <span style="margin-left: 15px;">tjänstebeskrivning</span>
                        </a>
                    </div>
                    <div class="index-text-wrapper">
                        <a href="#nyheter-section" class="index-text">
                            <span class="index-number">03</span>
                            <span style="margin-left: 15px;">ansvarsfriskrivning</span>
                        </a>
                    </div>
                    <div class="index-text-wrapper">
                        <a href="#kontakt-section" class="index-text">
                            <span class="index-number">04</span>
                            <span style="margin-left: 15px;">immateriella rättigheter</span>
                        </a>
                    </div>
                    <div class="index-text-wrapper">
                        <a href="#kontakt-section" class="index-text">
                            <span class="index-number">05</span>
                            <span style="margin-left: 15px;">personuppgiftshantering</span>
                        </a>
                    </div>
                </div>
                <div class="column">
                    <br>
                    <div class="index-text-wrapper">
                        <a href="#kontakt-section" class="index-text">
                            <span class="index-number">06</span>
                            <span style="margin-left: 15px;">ändringar av villkor</span>
                        </a>
                    </div>
                    <div class="index-text-wrapper">
                        <a href="#kontakt-section" class="index-text">
                            <span class="index-number">07</span>
                            <span style="margin-left: 15px;">tillämplig lag och tvistelösning</span>
                        </a>
                    </div>
                    <div class="index-text-wrapper"></div>
                        <div class="index-text">
                            <Link to="/about" style="text-decoration: none; color: inherit;">
                                <span class="index-number">08</span>
                                <span style="margin-left: 15px;">om oss</span>
                            </Link>
                        </div>
                    <div class="index-text-wrapper">
                    <div class="index-text">
                        <Link to="/" style="text-decoration: none; color: inherit;">
                            <span class="index-number">09</span>
                            <span style="margin-left: 15px;">boanalys</span>
                        </Link>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="om-oss-section" class="about-contact-container" style="margin-top: 100px;">
        <div>
            <span class="about-section-title">Allmänt</span>
            <div class="divider"></div>
            <p>
                Dessa allmänna villkor (”Villkoren”) reglerar användningen av applikationen och tjänsten Boanalys, 
                vilken tillhandahålls av Boan AB, ett svenskt bolag med organisationsnummer 559509-9101 och säte i STOCKHOLM. 
                Genom att registrera dig för eller på annat sätt använda Boanalys (”Tjänsten”) 
                bekräftar du att du har läst, förstått och godkänner Villkoren och förbinder dig att följa dem.
            </p>
        </div>
    </div>

    <div id="service-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Tjänstebeskrivning</span>
            <div class="divider"></div>
            <p>
                Boanalys tillhandahåller användare tillgång till ekonomisk data om svenska bostadsrättsföreningar. 
                Informationen baseras på offentlig data, årsredovisningar samt övrig finansiell information som analyseras med hjälp av AI-baserade metoder. 
                Syftet med Tjänsten är att underlätta för köpare, boende, mäklare, banker och andra intressenter att snabbt få en översikt över 
                centrala nyckeltal, ekonomisk ställning och relevant historik för en bostadsrättsförening.
            </p>
        </div>
    </div>

    <div id="nyheter-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Ansvarsfriskrivning</span>
            <div class="divider"></div>
            <p>
                <strong>Ingen garanti för korrekthet</strong>: All information och data i Tjänsten tillhandahålls ”i befintligt skick” utan några uttryckliga eller 
                underförstådda garantier avseende fullständighet, noggrannhet, riktighet, tillförlitlighet eller aktualitet. 
                Den tillgängliga informationen bygger på tredjepartsdatakällor, offentliga register samt AI-genererade analyser, 
                vilka kan vara ofullständiga, felaktiga eller inaktuella.
            </p>
            <p>
                <strong>Inget råd eller rekommendation</strong>: Informationen i Tjänsten ska inte betraktas som juridisk, ekonomisk, finansiell eller annan professionell rådgivning. 
                Du bör inte enbart förlita dig på Tjänsten vid beslut som rör köp, försäljning, finansiering eller förvaltning av bostadsrätter. 
                Boan AB rekommenderar alltid att du kompletterar informationen med egna undersökningar och vid behov konsulterar oberoende experter.
            </p>
            <p>
                <strong>Ansvarsfrihet för skador</strong>: Boanalys och Boan AB ansvarar inte för direkta, indirekta, tillfälliga, särskilda eller följdskador, förlust av data, intäkt, 
                inkomst, affärsmöjlighet eller förväntad besparing, som på något sätt uppkommer till följd av användning av Tjänsten eller dess information.
            </p>
            <p>
                <strong>Tekniska störningar</strong>: Boan AB garanterar inte att Tjänsten kommer att vara oavbruten eller felfri, eller att fel kommer åtgärdas omedelbart. 
                Eventuella driftstopp, buggar, virus eller andra tekniska problem kan uppstå utan förvarning. 
            </p>
        </div>
    </div>

    <div id="kontakt-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Immateriella Rättigheter</span>
            <div class="divider"></div>
            <p>
                Allt innehåll i Tjänsten, såsom logotyper, grafiska element, texter, data, kod och bakomliggande teknologi, tillhör Boan AB eller dess licensgivare. 
                All reproduktion, distribution, modifiering eller annan användning av sådant material utan skriftligt medgivande från Boan AB är förbjuden.
            </p>
        </div>
    </div>

    <div id="kontakt-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Personuppgiftshantering</span>
            <div class="divider"></div>
            <p>
                Om personuppgifter behandlas i samband med Tjänsten, sker detta i enlighet med gällande dataskyddslagstiftning, inklusive Dataskyddsförordningen (GDPR). 
                Information om hur Boan AB hanterar personuppgifter, användarens rättigheter samt kontaktuppgifter för dataskyddsfrågor finns 
                i Boan AB:s Integritetspolicy, som kan tillhandahållas separat.
            </p>
        </div>
    </div>

    <div id="kontakt-section" class="about-contact-container">
        <div>
            <span class="about-section-title">Ändringar av Villkor</span>
            <div class="divider"></div>
            <p>
                Boan AB förbehåller sig rätten att när som helst ändra dessa Villkor. Om väsentliga ändringar görs, 
                kommer du att meddelas på ett ändamålsenligt sätt, till exempel genom ett meddelande i Tjänsten eller via e-post. 
                Genom att fortsätta använda Tjänsten efter att ändringar trätt i kraft, anses du ha accepterat de uppdaterade Villkoren.
            </p>
        </div>
    </div>

    <div id="kontakt-section" class="about-contact-container" style="padding-bottom: 100px;">
        <div>
            <span class="about-section-title">Tillämplig Lag och Tvistelösning</span>
            <div class="divider"></div>
            <p>
                Dessa Villkor ska tolkas och tillämpas i enlighet med svensk lag. Eventuella tvister som uppstår med anledning av Tjänsten eller dessa Villkor 
                ska i första hand lösas genom förhandlingar mellan parterna. Om parterna inte kan enas ska tvisten prövas av svensk allmän domstol, 
                med STOCKHOLM tingsrätt som första instans.
            </p>
        </div>
    </div>

    <div class="black-div"></div>

    <footer class="footer">
        <p>&copy; 2023 Boanalys. All rights reserved.</p>
        <p>Contact: <a href="mailto:info@boanalys.io">info@boanalys.io</a></p>
    </footer>
</div>
